// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3XWfd":[function(require,module,exports,__globalThis) {
var _database = require("firebase/database");
var _config = require("./config");
var _storage = require("firebase/storage");
let databaseInstance = null, storageInstance = null;
const FIREBASE_HARDCODED_CONFIG = {
    apiKey: 'YOUR_API_KEY_HERE',
    databaseURL: 'https://YOUR_DATABASE_://firebaseio.com',
    projectId: 'YOUR_PROJECT_ID_HERE',
    storageBucket: 'YOUR_STORAGE_BUCKET_://appspot.com'
};
document.addEventListener('DOMContentLoaded', ()=>{
    initializeFirebasePipeline();
    document.getElementById('upload-btn').addEventListener('click', executeDatabaseAndCloudUpload);
    document.getElementById('print-local-btn').addEventListener('click', ()=>window.print());
    document.getElementById('reset-btn').addEventListener('click', resetFormWorkspace);
    initializeSignaturePad('canvas-landlord', 'clear-landlord', '#0f2d59');
    initializeSignaturePad('canvas-officer', 'clear-officer', '#b45309');
});
function setDefaultSystemDates() {
    const today = new Date().toISOString().split('T');
    document.getElementById('voucher-date').value = today[0];
    document.getElementById('sig-date').value = today[0];
}
function initializeFirebasePipeline() {
    //   const cfg = FIREBASE_HARDCODED_CONFIG;
    //   if (cfg.apiKey.includes('HERE')) {
    //     document.getElementById('status-display').innerText =
    //       'ERROR: Please update app.js with your hardcoded Firebase credentials.';
    //     return;
    //   }
    try {
        //const app = initializeApp(cfg);
        (0, _config.initFb)();
        databaseInstance = (0, _database.getDatabase)();
        storageInstance = (0, _storage.getStorage)();
        setDefaultSystemDates();
        generateAndSetNewVoucherId();
    } catch (e) {
        alert('Initialization Fail: ' + e.message);
    }
}
function generateAndSetNewVoucherId() {
    if (!databaseInstance) return;
    const uniqueVoucherKey = (0, _database.push)((0, _database.ref)(databaseInstance, 'DISB')).key;
    document.getElementById('data-voucherNum').value = uniqueVoucherKey;
    document.getElementById('status-display').innerText = 'Status: Connected. Modular Voucher ID ' + uniqueVoucherKey + ' allocated.';
}
function initializeSignaturePad(id, btnId, color) {
    const cvs = document.getElementById(id), ctx = cvs.getContext('2d'), btn = document.getElementById(btnId);
    function resize() {
        const r = cvs.getBoundingClientRect();
        cvs.width = r.width;
        cvs.height = r.height;
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
    }
    window.addEventListener('resize', resize);
    setTimeout(resize, 400);
    let draw = false;
    const pos = (e)=>{
        const r = cvs.getBoundingClientRect();
        return {
            x: (e.touches ? e.touches.clientX : e.clientX) - r.left,
            y: (e.touches ? e.touches.clientY : e.clientY) - r.top
        };
    };
    const start = (e)=>{
        draw = true;
        const p = pos(e);
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        e.preventDefault();
    };
    const move = (e)=>{
        if (draw) {
            const p = pos(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
        }
        e.preventDefault();
    };
    cvs.addEventListener('mousedown', start);
    cvs.addEventListener('mousemove', move);
    window.addEventListener('mouseup', ()=>draw = false);
    cvs.addEventListener('touchstart', start, {
        passive: false
    });
    cvs.addEventListener('touchmove', move, {
        passive: false
    });
    window.addEventListener('touchend', ()=>draw = false);
    btn.addEventListener('click', ()=>ctx.clearRect(0, 0, cvs.width, cvs.height));
}
async function executeDatabaseAndCloudUpload() {
    if (!databaseInstance || !storageInstance) return;
    // Reset any previous red validation highlights
    document.querySelectorAll('input, select').forEach((el)=>el.style.borderColor = '');
    // Define audit critical mandatory fields mapped by ID
    const requiredFieldIds = [
        'data-wireRef',
        'data-recipName',
        'data-recipId',
        'data-recipBank',
        'data-benefName',
        'data-address',
        'data-category',
        'data-description',
        'data-amtUsd'
    ];
    let missingFieldsCount = 0;
    requiredFieldIds.forEach((id)=>{
        const el = document.getElementById(id);
        if (!el || !el.value.trim()) {
            el.style.borderColor = '#ef4444'; // Highlight missing inputs in bright red
            missingFieldsCount++;
        }
    });
    const txt = document.getElementById('status-display');
    if (missingFieldsCount > 0) {
        txt.style.color = '#dc2626';
        txt.innerText = `VALIDATION FAILED: ${missingFieldsCount} required compliance field(s) are missing or blank.`;
        alert('Compliance Error:\n\nAll organizational, recipient, beneficiary, and financial fields are mandatory for international audit trails. Blank entries are not permitted.');
        return; // Halt system code loop routing execution
    }
    const vNum = document.getElementById('data-voucherNum').value;
    txt.style.color = '#1e40af';
    txt.innerText = 'Status: Exporting transactional schema components...';
    const payload = {
        voucherId: vNum,
        voucherDate: document.getElementById('voucher-date').value,
        wireRef: document.getElementById('data-wireRef').value,
        signDate: document.getElementById('sig-date').value,
        payeeName: document.getElementById('data-recipName').value,
        payeeId: document.getElementById('data-recipId').value,
        payeeBank: document.getElementById('data-recipBank').value,
        doneeName: document.getElementById('data-recipName').value,
        doneeAddress: document.getElementById('data-address').value,
        program: document.getElementById('data-category').value,
        purpose: document.getElementById('data-description').value,
        usdAmount: document.getElementById('data-amtUsd').value,
        localCurrency: (document.getElementById('data-currencyCode').value || '').toUpperCase(),
        localAmount: document.getElementById('data-amtLocal').value,
        date: new Date().getTime(),
        timestamp: new Date().toISOString()
    };
    try {
        await (0, _database.set)((0, _database.ref)(databaseInstance, 'DISB/' + vNum), payload);
        txt.innerText = 'Status: Compiling PDF matrix...';
        const blob = await html2pdf().set({
            margin: 0.2,
            filename: vNum + '_Voucher.pdf',
            image: {
                type: 'jpeg',
                quality: 0.98
            },
            html2canvas: {
                scale: 2,
                useCORS: true
            },
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait'
            }
        }).from(document.getElementById('invoice-render-target')).output('blob');
        txt.innerText = 'Status: Uploading PDF...';
        const fileRef = (0, _storage.ref)(storageInstance, `DISBFiles/${vNum}/${vNum}_Voucher.pdf`);
        await (0, _storage.uploadBytes)(fileRef, blob);
        const url = await (0, _storage.getDownloadURL)(fileRef);
        await (0, _database.set)((0, _database.push)((0, _database.ref)(databaseInstance, `disbFiles/${vNum}`)), url);
        const fIn = document.getElementById('additional-files-input');
        if (fIn.files.length > 0) for(let i = 0; i < fIn.files.length; i++){
            txt.innerText = `Status: Processing attachment [${i + 1}/${fIn.files.length}]...`;
            const attachmentRef = (0, _storage.ref)(storageInstance, `DISBFiles/${vNum}/attachments/${Date.now()}_${fIn.files[i].name}`);
            await (0, _storage.uploadBytes)(attachmentRef, fIn.files[i]);
            const aUrl = await (0, _storage.getDownloadURL)(attachmentRef);
            await (0, _database.set)((0, _database.push)((0, _database.ref)(databaseInstance, `disbFiles/${vNum}`)), aUrl);
        }
        document.querySelectorAll('input, select').forEach((el)=>{
            el.setAttribute('disabled', 'true');
            el.style.backgroundColor = '#e2e8f0';
        });
        document.getElementById('upload-btn').setAttribute('disabled', 'true');
        document.getElementById('upload-btn').style.backgroundColor = '#64748b';
        document.getElementById('clear-landlord').style.display = 'none';
        document.getElementById('clear-officer').style.display = 'none';
        document.getElementById('attachment-container').style.opacity = '0.5';
        txt.style.color = '#16a34a';
        txt.innerText = 'SUCCESS: Modular upload complete and interface form locked.';
        alert('All files and database structures synchronized successfully.');
    } catch (err) {
        txt.style.color = '#dc2626';
        txt.innerText = 'ERROR: ' + err.message;
    }
}
function resetFormWorkspace() {
    if (!confirm('Are you sure you want to clear all inputs and start a brand new voucher? Unsaved data will be lost.')) return;
    document.querySelectorAll('input, select').forEach((el)=>{
        if (el.id !== 'data-orgName' && el.id !== 'data-ein' && el.id !== 'data-orgEmail') el.value = '';
        el.removeAttribute('disabled');
        el.style.backgroundColor = '#fff';
        el.style.borderColor = '';
    });
    const upBtn = document.getElementById('upload-btn');
    upBtn.removeAttribute('disabled');
    upBtn.style.backgroundColor = '#0f2d59';
    document.getElementById('clear-landlord').style.display = 'block';
    document.getElementById('clear-officer').style.display = 'block';
    document.getElementById('attachment-container').style.opacity = '1';
    document.getElementById('status-display').style.color = '#1e40af';
    [
        'canvas-landlord',
        'canvas-officer'
    ].forEach((id)=>{
        const c = document.getElementById(id);
        c.getContext('2d').clearRect(0, 0, c.width, c.height);
    });
    setDefaultSystemDates();
    generateAndSetNewVoucherId();
}

},{"firebase/database":"3h9CB","./config":"324tf","firebase/storage":"9JHfQ"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["3XWfd"], "3XWfd", "parcelRequiredd39", {})

//# sourceMappingURL=receipt.66e5ee35.js.map
